export const AttachmentPreviewHeader = ({ customClassName = '' }: { customClassName?: string }) => {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={customClassName}>
      <g id="Capa 1">
        <path
          id="Vector"
          d="M4.40323 10.0635H13.2178V8.44676H4.40323V10.0635ZM4.40323 6.5253H17.621V4.94243H4.40323V6.5253ZM1.23716 17.7155C1.13291 17.8185 1.0018 17.8874 0.860177 17.9134C0.718555 17.9395 0.572687 17.9216 0.440763 17.8621C0.30884 17.8025 0.196698 17.7038 0.118322 17.5784C0.0399458 17.453 -0.00119612 17.3064 2.64779e-05 17.1568V2.21683C0.00249775 2.00474 0.0479997 1.79558 0.133555 1.60304C0.219111 1.4105 0.342792 1.23891 0.496506 1.09951C0.796378 0.785689 1.20246 0.606428 1.62783 0.600098L20.3476 0.600098C20.7786 0.601988 21.1913 0.781589 21.4952 1.09951C21.6516 1.23706 21.7776 1.40808 21.8647 1.6009C21.9518 1.79372 21.9979 2.00381 21.9998 2.21683V13.0007C22.0034 13.2159 21.9623 13.4293 21.8794 13.6265C21.7966 13.8237 21.6738 14 21.5196 14.1434C21.2157 14.4613 20.803 14.6409 20.372 14.6428H4.40323L1.23716 17.7155Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
